// Loading skeleton for the version history table — 5 placeholder rows.
//
// SHCT-707 — this used to be `animate-pulse` over `var(--muted)` (#ececf0), a
// near-white block pulsing on a white card: present in the DOM but invisible on
// screen, so a slow list read as "등록된 약관 버전이 없습니다." Switched to the shared
// `.skeleton-box` shimmer introduced by SHCT-481, which is the contrast level
// PRD 21 §8 asks for. The wrapper also carries `role="status"` + `aria-busy` so
// the loading state is announced, and a `terms-version-skeleton` hook so a probe
// looking for a loading indicator finds one.

import { useTranslation } from 'react-i18next';

export function VersionListSkeleton() {
  const { t } = useTranslation('terms');
  return (
    <div
      className="terms-version-skeleton"
      role="status"
      aria-busy="true"
      aria-label={t('list.loading')}
      style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="skeleton-box" style={{ height: 36 }} />
      ))}
    </div>
  );
}
